import styled from 'styled-components';
import ReactQuill from 'react-quill';
import { pickThemeFontStyles } from '@/theme';

export const StyledLabel = styled.div`
  display: flex;
  align-items: center;
  ${pickThemeFontStyles('12', '14', 'NORMAL')};
  margin-bottom: 0.5rem;

  &&& button {
    margin-left: 0.25rem;
  }
`;

export const StyledReactQuill = styled(ReactQuill)`
  .ql-editor ul {
    list-style: none;
    padding-left: 1.5rem;
  }

  .ql-editor ul li::before {
    content: '✔';
    color: black;
    font-weight: bold;
    display: inline-block;
    width: 1rem;
    margin-left: -1.5rem;
    margin-right: 0.5rem;
  }
`;
